import React from 'react';
import { Flex, Heading, Text } from '@chakra-ui/react';

export default function SectionHeader({
  title,
  description,
  action,
  mb = '18px',
}) {
  return (
    <Flex
      justify="space-between"
      align={{ base: 'flex-start', md: 'center' }}
      gap="12px"
      mb={mb}
      flexWrap="wrap"
      sx={{}}
    >
      <div>
        <Heading size="md" mb="6px">
          {title}
        </Heading>
        {description ? (
          <Text color="secondaryGray.700">{description}</Text>
        ) : null}
      </div>
      {action || null}
    </Flex>
  );
}
